import React, { createContext, useState, useContext } from "react";

const PatientContext = createContext();

export const usePatient = () => useContext(PatientContext);

export const PatientProvider = ({ children }) => {
  const [patientId, setPatientId] = useState(
    localStorage.getItem("patientId") || 0
  );
  const [patientName, setPatientName] = useState(
    localStorage.getItem("patientName")
  );
  const [patientPage, setPatientPage] = useState("");
  const [patientInfo, setPatientInfo] = useState(() => {
    try {
      return localStorage.getItem("patientInfo")
        ? JSON.parse(localStorage.getItem("patientInfo"))
        : null;
    } catch (e) {
      console.error("Error parsing patientInfo from localStorage", e);
      return {};
    }
  });
  const [hmoId, setHmoId] = useState("");
  const [hmoDetails, setHmoDetails] = useState({});
  const [diagnosis, setDiagnosis] = useState(null);
  const [appointmentId, setAppointmentId] = useState("");
  const [states, setStates] = useState(null);
  let userInfo = null;
  try {
    const userInfoRaw = localStorage.getItem("USER_INFO");
    userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
  } catch (e) {
    console.error("Error parsing USER_INFO from localStorage", e);
    userInfo = null;
  }
  const nurseRoles = userInfo?.role
    ? userInfo?.role.map((role) => role.toLowerCase().replace(/\s+/g, ""))
    : [];

  return (
    <PatientContext.Provider
      value={{
        diagnosis,
        setDiagnosis,
        states,
        setStates,
        patientId,
        setPatientId,
        appointmentId,
        setAppointmentId,
        patientName,
        setPatientName,
        patientPage,
        setPatientPage,
        hmoId,
        setHmoId,
        patientInfo,
        setPatientInfo,
        hmoDetails,
        setHmoDetails,
        nurseRoles,
      }}
    >
      {children}
    </PatientContext.Provider>
  );
};
